import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../utils/config';
import useStore from '../store/useStore';

// True module-level singleton - never recreated
let socketInstance = null;
let isConnecting = false;

export const getSocket = () => socketInstance;

const useSocket = () => {
  const { token, setUserOnline, setUserOffline, setTyping, clearTyping, setSocketConnected } = useStore();

  useEffect(() => {
    if (!token) return;
    if (socketInstance && socketInstance.connected) return;
    if (isConnecting) return;

    isConnecting = true;

    if (socketInstance) {
      socketInstance.disconnect();
      socketInstance = null;
    }

    socketInstance = io(SOCKET_URL, {
      auth: { token },
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
    });

    socketInstance.on('connect', () => {
      console.log('✅ Socket connected:', socketInstance.id);
      isConnecting = false;
      setSocketConnected(true);
    });

    socketInstance.on('connect_error', (err) => {
      console.error('Socket connect error:', err.message);
      isConnecting = false;
    });

    socketInstance.on('user_online', ({ user_id }) => setUserOnline(user_id));
    socketInstance.on('user_offline', ({ user_id }) => setUserOffline(user_id));
    socketInstance.on('user_typing', ({ user_id, full_name, conversation_id }) => {
      setTyping(conversation_id, user_id, full_name);
    });
    socketInstance.on('user_stop_typing', ({ conversation_id }) => {
      clearTyping(conversation_id);
    });
    socketInstance.on('disconnect', () => {
      console.log('❌ Socket disconnected');
      isConnecting = false;
      setSocketConnected(false);
    });

    // No cleanup - keep socket alive across re-renders
  }, [token]);

  return socketInstance;
};

export default useSocket;
